export default "__VITE_ASSET__Daxc5y7t__"